export const getFileType = (fileUrl: string): 'pdf' | 'image' | 'unknown' => {
  // Quitar query string (?...) y hash (#...) antes de leer la extensión.
  // Las URLs firmadas (HubSpot/CloudFront) traen ...pdf?Expires=...&Signature=...
  // y sin esto la "extensión" quedaría como "pdf?expires=..." → 'unknown'.
  const path = fileUrl.split('?')[0].split('#')[0];
  const extension = path.split('.').pop()?.toLowerCase();

  if (!extension) return 'unknown';

  if (extension === 'pdf') return 'pdf';

  if (['png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp'].includes(extension))
    return 'image';

  return 'unknown';
};
